export default __webpack_public_path__ + "static/media/ea-icon.ca322552.webp";